export default "__VITE_PUBLIC_ASSET__7891f262__"